import axiosInstance from '../Core/RestHelper';

export class RepoService {
    static async getRepos(): Promise<string[]> {
        try {
          const response = await axiosInstance.get('/git/repos');
          return response.data;
        } catch (error) {
          throw new Error('Failed to get GitHub auth URL');
        }
      }

      static async getBranches(repoName: string): Promise<string[]> {
        try {
          const response = await axiosInstance.post(`/git/repos/branches`, {"repo_name":repoName  });
          return response.data;
        } catch (error) {
          throw new Error('Failed to get GitHub auth URL');
        }
      }
}